import { render, staticRenderFns } from "./ApproveShiftModal.vue?vue&type=template&id=8dcdffb6&scoped=true"
import script from "./ApproveShiftModal.vue?vue&type=script&lang=js"
export * from "./ApproveShiftModal.vue?vue&type=script&lang=js"
import style0 from "./ApproveShiftModal.vue?vue&type=style&index=0&id=8dcdffb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcdffb6",
  null
  
)

export default component.exports